import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class SupplementService {

  constants: Constants = new Constants();

  constructor(private readonly http: HttpClient) { }

  HTTP_CONSTANT_OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
      'Accept': 'application/json',
    })
  };


 


  getSuppData(requestData: any): Observable<any> {
    console.info("Entered Supplement Data");
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
    .post(
      this.constants.getApiBasePath() + `/maxloadData/getSupplementData/`, 
      requestData, { headers, responseType: 'json' })
    .pipe(
      tap(_ => this.log('Supplement View Button PDF Successful')),
      catchError(this.handleError<any>('Supplement View Button PDF Generated Error'))
    );
}

  private handleError<T>(_operation, result?: T) {
    return (error: any): Observable<T> => {
      console.info(error); // log to console instead
      return of(result as T);
    };
  }

  /** Log a message */
  private log(message: string) {
    console.info('Message: ' + message);
  }



}
